import AvatarSelector from './src/avatar-selector';

export default AvatarSelector;
